import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const SOCIAL_LINKS = [
  {
    href: 'https://www.linkedin.com/in/harrisonalexander',
    icon: faLinkedin,
    label: 'LinkedIn',
  },
  {
    href: 'https://github.com/alexkendall',
    icon: faGithub,
    label: 'GitHub',
  },
] as const;

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-links">
        {SOCIAL_LINKS.map(({ href, icon, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="site-footer-link"
          >
            <FontAwesomeIcon icon={icon} size="2x" />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </footer>
  );
}

export default Footer;
